export default "__VITE_ASSET__DtxDiJ0E__"